import { type FC } from 'react';
import { OverlayView } from './Overlay/OverlayView.tsx';
import { Spinner } from 'dibs-elements/exports/Spinner.tsx';
import styles from './loadingComponent.module.css';

const LoadingComponent: FC = () => (
    <OverlayView isTransparent isAboveOverlay isBodyScrollLocked={false}>
        <Spinner dark containerClass={styles.centeredDiv} />
    </OverlayView>
);

export { LoadingComponent };
